module.exports = __webpack_public_path__ + "static/img/ms-sql.b3628a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/ms-sql.jpg
// module id = mThk
// module chunks = 0